import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { FileField } from 'libs/forms/views/fieldTypes/file';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';
import { Cropper } from 'apps/components/cropper';

import TagsList from 'apps/project/views/tagsList';

import {
  MainSectionWrapper,
  ImageStyled,
  ProjectImageWrapper,
} from 'apps/project/views/projectImage.styles';

export const ProjectImage = observer(props => {
  const { app, formStore, fieldName } = props;
  return (
    <MainSectionWrapper>
      <TagsList app={app} />
      {app.editing ? (
        <FileField
          editComponent={ProjectImageWrapper}
          previewComponent={Cropper}
          fieldStore={formStore.fieldStores.get(fieldName)}
        />
      ) : (
        <ImageStyled
          src={imageSrc(
            app[fieldName],
            app.imageFallbackPath,
            mainConf.imgSizes.project.large,
          )}
          alt={app.name}
        />
      )}
    </MainSectionWrapper>
  );
});

ProjectImage.propTypes = {
  app: PropTypes.object,
  formStore: PropTypes.object,
  fieldName: PropTypes.string,
};
